import React, { Component } from 'react';
import { HelpModalContext } from './HelpModalContext';

export const helpModalControl = (WrappedComponent) => {
  // eslint-disable-next-line react/prefer-stateless-function,react/no-multi-comp
  class HelpModalControl extends Component {
    render() {
      const { toggle } = this.context;
      return <WrappedComponent {...this.props} toggleHelpModal={toggle} />;
    }
  }

  HelpModalControl.contextType = HelpModalContext;

  return HelpModalControl;
};
